var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.currentUser)?_c('h1',[_vm._v("Logged in")]):_c('h1',[_vm._v("Log in above")])])}
var staticRenderFns = []

export { render, staticRenderFns }